<template>
  <div class="personManage" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="title-main">
      <h3>人员管理</h3>
    </div>
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item label="姓名：">
        <el-input v-model="formInline.serviceName" placeholder="请输入姓名" class="el-input_height"></el-input>
      </el-form-item>
      <el-form-item style="width:240px; margin: 0;">
        <el-radio-group v-model="formInline.serviceSex">
          <el-radio label="">全部</el-radio>
          <el-radio :label="0">男</el-radio>
          <el-radio :label="1">女</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item style="width:320px; margin: 0;">
        <el-radio-group v-model="formInline.serviceType">
          <el-radio label="">全部</el-radio>
          <el-radio :label="1">家长</el-radio>
          <el-radio :label="2">教练</el-radio>
          <el-radio :label="3">领队</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item style="width:80px;margin:0 20px;">
        <el-button type="primary" @click="onSubmit" class="bb" round>查询</el-button>
      </el-form-item>
    </el-form>
    <div class="table clear">
      <el-button type="primary" @click="changePerson('add',null)" class="bb" round >增加人员</el-button>
      <!--<a type="primary" href="/marlin/sign/data/club/member/export" style="border-radius: 20px;" class="el-button el-button&#45;&#45;primary bb">导出EXCEL</a>-->
      <span style="float: right;line-height: 50px;">共{{person}}人</span>
    </div>

    <div class="elTable">
      <el-table
        :data="tableData"
        border
        resizable="false"
        @cell-mouse-enter="cellMouseEnter"
        @cell-mouse-leave="cellMouseLeave"
        style="width: 100%">
        <el-table-column
          label="姓名"
          align="center">
          <template slot-scope="scope" >
            <div >
              <span style="color: #44c1de;cursor: pointer;" @click="changePerson('update', scope.row)"> {{scope.row.serviceName}}</span>
            </div>

          </template>
        </el-table-column>
        <el-table-column
          label="性别"
          width="60"
          align="center">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{scope.row.serviceSex | sexToData}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="serviceCertNumber"
          label="证件号码"
          width="180"
          align="center">
        </el-table-column>
        <el-table-column
          label="手机号码"
          width="120"
          align="center"
          prop="serviceMobile">
        </el-table-column>

        <el-table-column
          label="类别"
          width="80"
          align="center">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{scope.row.serviceType | serviceTypeTodata}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作"
                         fixed="right"
                         width="100"
                         align="center">
          <template slot-scope="scope">
            <div>
              <el-button
                size="mini"
                type="danger"
                icon="el-icon-delete"
                @click="handleDelete(scope.$index, scope.row)">

              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!--增加人员-->
    <el-dialog title="增加人员" :visible.sync="dialogFormVisible" width="400px" @close="cancel">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="姓名" prop="serviceName" style="display: inline-block;">
          <el-input v-model="ruleForm.serviceName" :maxlength="50" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="性别" prop="serviceSex">
          <el-radio-group v-model="ruleForm.serviceSex">
            <el-radio label="0" >男</el-radio>
            <el-radio label="1" >女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="类别" prop="serviceType">
          <el-radio-group v-model="ruleForm.serviceType">

            <el-radio label="1" >家长</el-radio>
            <el-radio label="2" >教练</el-radio>
            <el-radio label="3" >领队</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="证件号码" style="display: inline-block;">
          <el-input v-model="ruleForm.serviceCertNumber" :maxlength="50" placeholder="请输入证件号码"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="serviceMobile" style="display: inline-block;">
          <el-input v-model="ruleForm.serviceMobile" :maxlength="11" placeholder="请输入手机号"></el-input>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer" >
        <el-button type="primary" @click="submitForm('ruleForm')" class="bb"round>确定</el-button>
        <el-button @click="cancel" round >取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import axios from 'axios'
  export default {
    data() {
      return {
        clubInfos:JSON.parse(sessionStorage.getItem("clubInfos")),
        href:'',
        fullscreenLoading: false,
        disabled1:false,
        userInfos: {},
        formInline: {
          "clubCode":"",//俱乐部编码 必填
          "serviceCode":"",//服务人员编码 选填
          "serviceType":"",//服务人员类型 0-家长 1-教练 2-领队 选填
          "serviceSex":"",//服务人员性别 0-男 1-女 选填
          "serviceName":"",//服务人员姓名 选填
          "pageSize":15,//每页数量 必填
          "pageIndex":1//页码 必填
        },
        option:[],
        optionend:[],
        person:null,

        tableData: [],

        addForm:{

        },
        editFormVisible:false,
        dialogFormVisible:false,
        formLabelWidth:'120px',
        handle:'',
        ruleForm: {
          "clubCode":"",//俱乐部编码 //必填
          "serviceType":"0",//服务人员类型 0-家长 1-教练 2-领队 //必填
          "serviceSex":"0",//服务人员性别 0-男 1-女 //必填
          "serviceName":"",//服务人员姓名 //必填
          "serviceCertNumber":null,//证件号码 选填
          "serviceMobile":""//手机号码 必填
        },
        editForm:{
          "memberName":"",//成员姓名 //必填
          "memberSex":null,//成员性别 0-男 1-女  必填
          "memberIdCard":"",//身份证号码 必填
          "memberBith":"", //出生日期 必填
          "memberHeight":null,//身高 CM 必填
          "memberWeight":null,//体重 KG 必填
          "memberLevel":null,//运动员等级 0-大众 1-专业 必填
          "memberWeapon":null,//剑种 1-花剑 2-重剑 3-配剑 必填
          "memberWay":null,//持剑手 0-未知 1-左手 2-右手 必填
          "memberContactName":null,//紧急联系人 必填
          "memberContactTel":null,//紧急联系人电话 必填
          "memberIdType":"0"
        },
        rules: {
          serviceName: [
            { required: true, message: '请输入姓名', trigger: 'blur' },
          ],
          serviceSex: [
            { required: true, message: '请选择性别', trigger: 'change' }
          ],
          serviceType: [
            { required: true, message: '请选择类别', trigger: 'change' }
          ],
          serviceCertNumber:[
            { required: true, message: '请输入证件号码', trigger: 'blur' },
          ],

          serviceMobile:[
            { required: true, message: '请输入联系人号码', trigger: 'blur' },
          ],

        }
      };
    },
    filters: {
      timestampToDate(data) {
        return global.timestampToDate(data);
      },
      levelTodata(val){
        return val==0 ? '大众':'专业'
      },
      WeaponToData(val){
        if(val==1){
          return val='花剑'
        }else if(val==2){
          return val='重剑'
        }else if(val==3){
          return val='佩剑'
        }
      },
      sexToData(val){
        return val==0 ? '男':'女'
      },
      memberWayToData(val){
        if(val==0){
          return val='未知'
        }else if(val==1){
          return val='左手'
        }else if(val==2){
          return val='右手'
        }
      },
      serviceTypeTodata(val){
        if(val==1){
          return val='家长'
        }else if(val==2){
          return val='教练'
        }else if(val==3){
          return val='领队'
        }
      }
    },
    mounted() {
      for(var i=0;i<70;i++){
        var l=(2018-i)
        var v=(2018-i)+'-01-01'
        var o={value:v,label:l}
        this.option.push(o)

        var vend=(2018-i)+'-12-31'
        var oend={value:vend,label:l}
        this.optionend.push(oend)
      }
      this.onSubmit()
    },

    methods: {
      memberIdTypeChange(){
        this.ruleForm.memberBith=""
        this.editForm.memberBith=""
      },
      changePerson(handle,row){
        this.handle=handle
        if(row!=null){
          this.ruleForm=row
          this.ruleForm.serviceType=''+row.serviceType
          this.ruleForm.serviceSex=''+row.serviceSex
        }
        this.dialogFormVisible=true
      },
      onSubmit() {
        this.formInline.clubCode=this.clubInfos.clubCode
        var self=this
        axios.post('/marlin/sign/club/service/query/list',this.formInline)
          .then(function(res){
            if(res.data.code==0){
              self.tableData=res.data.rst

              self.person=res.data.count
              console.log(res)

            }else{
              self.$message({
                message: res.data.msg,
                type: 'warning'
              });
            }
          })
          .catch(function(err){
            overdue(err.response,err.response.status,self)
          })
      },
      //增加人员
      submitForm(formName) {
        let self=this
        this.$refs[formName].validate((valid) => {
          if (valid) {

            if(null==self.ruleForm.serviceCertNumber || ""== self.ruleForm.serviceCertNumber){
              self.ruleForm.serviceCertNumber=null
            }
            var postData=self.ruleForm
            postData.clubCode=self.clubInfos.clubCode
            if(this.handle=='update'){
              postData.serviceCode=self.ruleForm.serviceCode
            }
            console.log(postData)
            axios.post('/marlin/sign/club/service/'+this.handle,postData)
              .then(function(res){
                if(res.data.code==0){
                  self.$message({
                    message: res.data.msg,
                    type: 'success'
                  });
                  self.dialogFormVisible=false
                  self.onSubmit()
                  console.log(res)

                }else{
                  self.$message({
                    message: res.data.msg,
                    type: 'warning'
                  });
                }
              })
              .catch(function(res){
                overdue(res.response,res.response.status,self)
              })
          } else {
            return false;
          }
        });
      },
      cancel(){
        this.onSubmit()
        this.dialogFormVisible=false
        this.ruleForm={
          "clubCode":"",//俱乐部编码 //必填
            "serviceType":"0",//服务人员类型 0-家长 1-教练 2-领队 //必填
            "serviceSex":"0",//服务人员性别 0-男 1-女 //必填
            "serviceName":"",//服务人员姓名 //必填
            "serviceCertNumber":null,//证件号码 选填
            "serviceMobile":""//手机号码 必填
        }

      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      change(val){
      },
      handleDelete(index, row) {
        var self=this
        this.$confirm('此操作会删除此条记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          axios.get('/marlin/sign/club/service/delete/'+row.serviceCode)
            .then(function(res){
              if(res.data.code==0){
                self.$message({
                  message:'您已删除成功！',
                  type:'success'
                })
                self.onSubmit()
              }else{
                self.$message({
                  message:res.data.msg,
                  type:'warning'
                })
              }
            })
            .catth(function(res){
              overdue(res.response,res.response.status,self)
            })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      timestampToDate(data) {
        return global.timestampToDate(data);
      },

      selectStar(val){
      },
      changeCount(){
        var IdCard=this.ruleForm.memberIdCard
        if(null!=IdCard && IdCard.length == 18){
          var newIdCard=IdCard.substring(6,10)+'-'+IdCard.substring(10,12)+'-'+IdCard.substring(12,14)
          this.ruleForm.memberBith=newIdCard
          IdCard==''
        }else{
          IdCard==''
        }

      },

      changeCount1(){
        var IdCard=this.editForm.memberIdCard
        if(null!=IdCard && IdCard.length == 18){
          var newIdCard=IdCard.substring(6,10)+'-'+IdCard.substring(10,12)+'-'+IdCard.substring(12,14)
          this.editForm.memberBith=newIdCard
          IdCard==''
        }else{
          IdCard==''
        }
      },
      cellMouseEnter(row,column,cell,event){
        row.id=0
      },
      cellMouseLeave(row,column,cell,event){
        row.id=1
      }
    }
  }
</script>

<style  lang="less" scoped>
  .personManage{
    .el-form-item{
      /*width: 320px;*/
    }
    .el-input input{
      border-radius:20px !important;
    }
  }

  .table{
    margin-top: 10px;
  }
  .elTable{
    margin-top: 20px;
  }
  .el-form-item{
    margin-bottom: 18px;
  }
  .cell span{
    margin-left: 0 !important;
  }
  .bb{
    background-color: #44c1de;
    border:1px solid #44c1de;
    padding: 8px 15px;
  }
  .el-button{
    padding: 8px 15px !important;
    font-size: 14px;
  }
  .el-radio__input.is-checked+.el-radio__label{
    color: #44c1de;
  }
  .el-radio__input.is-checked .el-radio__inner {
    border-color: #44c1de;
    background: #44c1de;
  }
  .el-table th{
    background:rgb(97, 107, 136) !important;
    color: #fff !important;
  }
  .el-table--border{
    border-radius:10px ;
  }
  .auditMsg .el-input__inner{
    height: 34px !important;
    line-height: 34px !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/personManage.vue